import React from "react";

const AboutGlobalCommunitySection = ({ data }) => (

    <section
        className="student-global-section"
        id="community"
    >
{console.log("GLOBAL:::",data)}
        <div className="container">

            <div className="student-section-header">

                <span className="student-eyebrow">
                    {data.eyebrow}
                </span>

                <h2>
                    {data.title}
                    <span>{data.highlight}</span>
                </h2>

                <p>
                    {data.description}
                </p>

            </div>


            <div className="student-global-content">

                <div className="global-placeholder">

                    <span>
                        {data.community.label}
                    </span>

                    <h3>
                        {data.community.title}
                    </h3>

                    <p>
                        {data.community.description}
                    </p>

                </div>

            </div>

        </div>

    </section>
);

export default AboutGlobalCommunitySection;